import React, { useEffect, useMemo, useState } from 'react';
import { getLabCatalog, getLabNearLimitDrift } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabFilterBar from '../components/LabFilterBar';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function NearLimitDriftPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [catalog, setCatalog] = useState(null);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState('');
  const [station, setStation] = useState('');
  const [units, setUnits] = useState('');

  useEffect(() => {
    getLabCatalog(sharedQuery).then(setCatalog).catch(() => {});
    getLabNearLimitDrift(sharedQuery).then((data) => setRows(data.rows || []));
  }, [sharedQuery]);

  const filteredRows = useMemo(() => rows.filter((row) => {
    const text = `${row.stationName} ${row.stepName} ${row.units} ${row.stepNumber}`.toLowerCase();
    const stationOk = !station || row.stationName === station;
    const unitsOk = !units || row.units === units;
    return text.includes(search.toLowerCase()) && stationOk && unitsOk;
  }), [rows, search, station, units]);

  return (
    <div className="lab-page">
      <LabCard title="Deriva near-limit" description="Misure numeriche di produzione raggruppate per step e stazione, ordinate per pressione near-limit.">
        <LabFilterBar>
          <input className="lab-input" placeholder="Filtra per stazione, step, unità o numero step" value={search} onChange={(event) => setSearch(event.target.value)} />
          <select className="lab-input" value={station} onChange={(event) => setStation(event.target.value)}>
            <option value="">Tutte le stazioni</option>
            {(catalog?.production?.stations || []).map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
          <select className="lab-input" value={units} onChange={(event) => setUnits(event.target.value)}>
            <option value="">Tutte le unità</option>
            {(catalog?.production?.units || []).map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
        </LabFilterBar>
        <LabTable
          rows={filteredRows}
          emptyTitle="Questo insight richiede valori numerici e limiti."
          emptyDescription="Smarti Lab non ha trovato abbastanza righe numeriche con limiti basso e alto validi."
          columns={[
            { key: 'stationName', label: 'Stazione' },
            { key: 'stepName', label: 'Step' },
            { key: 'measureType', label: 'Tipo misura' },
            { key: 'units', label: 'Unità' },
            { key: 'near5Count', label: 'Near 5%' },
            { key: 'near10Count', label: 'Near 10%' },
            { key: 'near10Rate', label: 'Tasso near 10%' },
            { key: 'avgValue', label: 'Media' },
            { key: 'trendDirection', label: 'Trend' },
            { key: 'riskLabel', label: 'Rischio', render: (value) => <LabRiskBadge label={value} /> },
          ]}
        />
      </LabCard>
    </div>
  );
}
